import api from '../../services/template';
export default function (helper) {
  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('template');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({
    copyContent(context, params) {
      helper
        .log()
        .info(`[Store: Template}]: Copy template content into program`, params);
      return new Promise((resolve, reject) => {
        return helper
          .api()
          .copyContent(params)
          .then((response) => {
            helper
              .log()
              .info(`[Store: Template]: Copied template content into program`, response.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            helper
              .log()
              .info(`[Store: Template]: Error Copying template content into program`, error);
            reject(error);
          })
      });
    },
    create(context, params) {
      helper
        .log()
        .info(`[Store: Template]: Create new template`, params.data);
      return new Promise((resolve, reject) => {
        return helper
          .api()
          .create(params.data)
          .then((response) => {
            helper
              .log()
              .info(`[Store: Template]: Created new template`, response.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            helper
              .log()
              .info(`[Store: Template]: Error Creating new template`, error);
            reject(error);
          })
      });
    },
    getTypes(context, params) {
      helper
        .log()
        .info(`[Store: Template]: Get Template Types`, params);
      return new Promise((resolve, reject) => {
        return helper
          .api()
          .types(params)
          .then((response) => {
            helper
              .log()
              .info(`[Store: Template]: Got Template Types`, response.data);
            resolve(response.data);
          })
          .catch((error) => {
            helper
              .log()
              .info(`[Store: Template]: Error Getting Template Types`, error);
            reject(error);
          })
      });
    },
  }, 'Template');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}